import {BootstrapModalModule} from "../bootstrap-modal/bootstrap-modal.module";
import {BrowserModule} from "@angular/platform-browser";
import {NgModule} from "@angular/core";
import {PrintPreviewService} from "./print-preview.service";
import {PrintableDirective} from "./printable.directive";
import {PrintOnClickDirective} from "./print-on-click.directive";
import {PrintPreviewHelperDialogComponent} from "./print-preview-helper-dialog.component";

@NgModule({
  providers: [PrintPreviewService],
  imports: [
    BrowserModule,
    BootstrapModalModule,
  ],
  declarations: [
    PrintableDirective,
    PrintOnClickDirective,
    PrintPreviewHelperDialogComponent,
  ],
  exports: [
    PrintableDirective,
    PrintOnClickDirective,
  ],
  entryComponents: [
    PrintPreviewHelperDialogComponent,
  ],
})
export class PrintPreviewModule {}
